import { cn } from '@/lib/utils'

export function MetricCard({
  label,
  value,
  caption,
  captionClassName,
}: {
  label: React.ReactNode
  value: React.ReactNode
  caption?: React.ReactNode
  captionClassName?: string
}) {
  return (
    <div className="rounded-xl border border-border bg-card p-5 shadow-sm">
      <div className="text-sm text-muted-foreground">{label}</div>
      <div className="mt-1 text-3xl font-semibold" data-numeric>
        {value}
      </div>
      {caption && <div className={cn('mt-1 text-xs text-muted-foreground', captionClassName)}>{caption}</div>}
    </div>
  )
}
